import { isFunction } from 'lodash'
import { AutocomplateInputModeMap, ElHasInputComponents } from './config'

/**
* 获取元素XPath
* @param {Element}
* @return {xpath}
*/
export const getXPathForElement = (element) => {
  if (element && element.id) {
    return 'id("' + element.id + '")'
  } else if (element === document.body) {
    return element.tagName.toLowerCase()
  }

  let ix = 0
  let siblings = element.parentNode.childNodes
  for (let i = 0; i < siblings.length; i++) {
    let sibling = siblings[i]
    if (sibling === element) {
      return getXPathForElement(element.parentNode) + '/' + element.tagName.toLowerCase() + '[' + (ix + 1) + ']'
    }
    if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
      ix++
    }
  }
}

/**
* 获取当前元素的唯一ID
* @param {Element}
* @return {id}
*/
export function getElementUniqueId(el) {
  const { employeeNumber } = window.__ERPUSER__
  const elId = el.id || getXPathForElement(el)
  const id = employeeNumber ? (`${employeeNumber}:${elId}`) : elId
  return {
    id
  }
}

/**
* 获取组件name
* @param {组件实例}
* @return {componentName}
*/
export function getComponentName(componentInfo) {
  if (!componentInfo) return ''
  const { $options, $vnode = {} } = componentInfo
  let componentName = $options.componentName || $options.name
  if (!componentName) {
    // 兜底
    const componentNameIndex = $vnode.tag && $vnode.tag.lastIndexOf('-')
    componentName = $vnode.tag && componentNameIndex > -1 && $vnode.tag.substr(componentNameIndex + 1)
  }
  return kebabToCamel(componentName)
}

/**
* 按 - 连接符转成大驼峰
* @param {str}
*/
function kebabToCamel(str) {
  if (!str) return ''
  return capitalizeFirstLetter(str.replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : '')))
}

/**
* 把第一个字符转为大写
* @param {str}
*/
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function emptyFn() {}

// 责任链方式
export class AutocompleteValidationChain {
  constructor() {
    this.validationFunctions = []
  }
  addValidationFunction(validationFn) {
    if (isFunction(validationFn)) {
      this.validationFunctions.push(validationFn)
    }
    return this
  }
  executeValidations(el, options) {
    for (const validationFunction of this.validationFunctions) {
      if (!validationFunction(el, options)) {
        return false
      }
    }
    return true
  }
}


export function getCurrentRouteInfo() {
  const { currentRoute } = window.__ERP_PUBLIC_SHARED_ROUTER__ || {}
  return currentRoute || {}
}

export function isValidIndex(index, array) {
  return index >= 0 && index < array.length
}

export function isErpElInputAutoComplate(el) {
  const { mode } = el._erpInputAutoCompleteConfig || {}
  return mode === AutocomplateInputModeMap.autocomplate
}

export function isErpElSelectRemote(el = {}) {
  const { componentsType } = el._erpInputAutoCompleteConfig || {}
  if (componentsType === ElHasInputComponents.ElSelect) {
    return true
  }
  return el.className.includes('el-select__input')
}

export function getErpElSelectRemoteVm(el) {
  const _el = el && el.parentNode && el.parentNode.parentNode
  return _el && _el.__vue__
}


export function isInputActive() {
  const focusedElement = document.activeElement
  return focusedElement && focusedElement.tagName === 'INPUT'
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/utils.js